import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import { getColumnName } from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/utils";

export class NoDuplicateDoorsRule extends Validator<IAttributeData[], IAttributeDataError> {
    keyField: string;

    constructor(keyField: string) {
        super();
        this.keyField = keyField;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let duplicatedRows = [];
        const fieldName = getColumnName(model[0], this.keyField);
        if (!errors[RuleType.NoDuplicateRowRule] && fieldName) {
            duplicatedRows = [
                ...model.reduce(
                    (acc, item) => {
                        const rowId = item[fieldName];
                        if (!acc.unique.has(rowId)) {
                            acc.unique.add(rowId);
                        } else {
                            acc.duplicated.add(rowId);
                        }

                        return acc;
                    },
                    { unique: new Set(), duplicated: new Set() }
                ).duplicated,
            ];
        }

        const validationErrors = duplicatedRows.length
            ? {
                  ...errors,
                  [RuleType.NoDuplicateRowRule]: formatMessage(
                      "Your file contains duplicate rows for door ID(s): |ids|. Please remove these rows from your file.",
                      {
                          ids: duplicatedRows.join(", "),
                      }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
